import { formatDistanceToNow } from "date-fns";
import { useEffect, useState } from "react";

function TimeAgo({ classes }) {
  const currentDatetime = new Date();
  const getFormattedDistanceToNow = () => {
    return formatDistanceToNow(currentDatetime);
  };
  const [timeAgoWords, setTimeAgoWords] = useState(getFormattedDistanceToNow);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeAgoWords(getFormattedDistanceToNow);
    }, 60000);
    return () => {
      window.clearInterval(timer);
    };
  }, []);

  return `${timeAgoWords} ago.`;
}

export default TimeAgo;
